/*
  Calyan Cart Drawer Enhancements
  Works with Wonder Theme's cart-drawer public API. The listener is delegated
  from document because Wonder replaces CartDrawer HTML after every cart change.
*/
(function () {
  'use strict';

  const getCartDrawer = () => document.querySelector('cart-drawer');

  const setButtonLoading = (button, isLoading) => {
    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const showDrawerError = (message) => {
    const errors = document.getElementById('CartDrawer-CartErrors');
    if (errors) {
      errors.textContent = message;
    }
  };

  const getErrorMessage = (payload) => {
    if (!payload) return 'Unable to add this item. Please try again.';
    return payload.description || payload.message || 'Unable to add this item. Please try again.';
  };

  const addVariantToCart = async (variantId, button) => {
    const cartDrawer = getCartDrawer();
    const formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
      if (sections.length) formData.append('sections', sections.join(','));
    }

    setButtonLoading(button, true);
    showDrawerError('');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(getErrorMessage(data));
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        cartDrawer.renderContents(data, false);
      } else if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
        await cartDrawer.refreshCartDrawer();
      } else {
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        return;
      }
    } catch (error) {
      showDrawerError(error.message || 'Unable to add this item. Please try again.');
      setButtonLoading(button, false);
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-calyan-cart-add]');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();
    addVariantToCart(variantId, button);
  });
}());
